import type { Layout } from '../../data/types';
import type { WindmillSetting } from './windmillForms';

type Windmill = Layout['windmills'][number];
type Tower = Layout['fortifications']['towers'][number];

export function windmillSetting(mill: Windmill): WindmillSetting {
  return mill.tower === undefined ? 'ground' : 'wall';
}

/*
 * Height of the ground a mill stands on. A wall mill stands on its tower's floor, which the
 * fortifications build at the tower's height inside the parapet of a flat top (towers.ts
 * buildFlatTop); a roofed tower has no floor to stand on, so the layout pairing it with a mill is
 * refused rather than drawn with the mill inside the roof.
 */
export function windmillBase(mill: Windmill, towers: readonly Tower[]): number {
  if (mill.tower === undefined) return 0;
  const tower = towers.find((t) => t.id === mill.tower);
  if (!tower) throw new Error(`${mill.id} stands on tower ${mill.tower}, which is missing`);
  if (tower.roof !== 'flat') {
    throw new Error(`${mill.id} stands on ${tower.id}, whose roof is ${tower.roof}, not flat`);
  }
  return tower.height;
}
